<div  [ngStyle]="{'border-bottom':(textStyle && textStyle.includes('underline')) ? '1px solid black':null,
'textAlign':textAlign}">
    <span [ngStyle]="{'fontWeight':(textStyle && textStyle.includes('bold')) ? 'bold' : 'inherit',
'fontStyle':(textStyle && textStyle.includes('italic')) ? 'italic' : 'inherit' ,
'word-break':(textStyle && textStyle.includes('break')) ? 'break-all' : 'unset',
'color':color
}">
{{value ? value : '&nbsp;' }}</span>
</div>